import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useApp } from './AppContext';
import { useTranslation } from '../i18n/TranslationContext';

export function ContractComplete() {
  const { navigateDirectly } = useApp();
  const { t } = useTranslation();

  const handleContinueToIDCheck = () => {
    navigateDirectly('id-terms');
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] mb-6">
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 bg-[var(--ucm-light-green)] rounded-full flex items-center justify-center mr-3">
          <CheckCircle size={16} className="text-[var(--ucm-dark-green)]" />
        </div>
        <h3 className="font-semibold text-[var(--ucm-text-dark)]">{t('contract.process.title')}</h3>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-[var(--ucm-text-medium)]">{t('contract.status.label')}:</span>
          <span className="text-sm font-semibold text-[var(--ucm-success-green)]">✅ {t('contract.status.complete')}</span>
        </div>
        <p className="text-sm text-[var(--ucm-text-medium)] mb-3">
          {t('contract.complete.description')}
        </p>
        
        <div className="bg-[var(--ucm-light-green)] rounded-xl p-3 mb-4">
          <p className="text-xs text-[var(--ucm-dark-green)]">
            {t('contract.complete.note')}
          </p>
        </div>
        
        <div className="text-xs text-[var(--ucm-text-light)] mb-4">
          {t('contract.progress.complete', { current: 5, total: 8 })}
        </div>
      </div>

      <button
        onClick={handleContinueToIDCheck}
        className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center"
      >
        {t('contract.complete.continueToIDCheck')}
        <ArrowRight size={16} className="ml-2" />
      </button>
    </div>
  );
}